import { render, staticRenderFns } from "./CheckBoxGroup.vue?vue&type=template&id=15ed2aac&scoped=true"
import script from "./CheckBoxGroup.vue?vue&type=script&lang=js"
export * from "./CheckBoxGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15ed2aac",
  null
  
)

export default component.exports